
import { expertSolutionList } from 'data/street';
import SlideItems from './SlideItems';

const Slide = () => {

  /**
   * Expert Solution 데이터 리스트를 특정 타입별로 정렬 합니다.
   */
  const getSortFilterList = (type: number) => {
    const returnSortFilterList: any[] = [];
    for (const es of expertSolutionList) {
      if(es.type == type) {
        returnSortFilterList.push(es);
      }
    }
    return returnSortFilterList;
  }

  return (
    <>
      <div className="system-title">시스템</div>
      <SlideItems title="안전 시스템" list={getSortFilterList(1)} />
      <SlideItems title="에너지 절약 시스템" list={getSortFilterList(2)} />
      <SlideItems title="건강 시스템" list={getSortFilterList(3)} />
      <SlideItems title="편의 시스템" list={getSortFilterList(4)} />
      <SlideItems title="소음저감 시스템" list={getSortFilterList(5)} />
      <div className="detail">
        * 본 홈페이지 시스템 이미지는 입주자 이해를 돕기 위한 것으로 실제와 다를 수 있습니다.
      </div>
    </>
  );
};

export default Slide;
